/**
 * Past-editions rail on the retail-show layout
 * (Elements/newsstudios/RETAIL_B.ctp, Layouts/retail-show.ctp).
 *
 * The mockup's rail is a scroll-snap strip with two hand-wired arrow buttons.
 * Splide instead, for the same reasons as lib/hero.js — swipe, keyboard, ARIA,
 * and the arrows' disabled state at the ends for free — and because it is
 * already in the bundle.
 *
 * `fixedWidth`, not `perPage`: the cards are posters of one width (15rem,
 * 17rem from `lg`, as the mockup draws them) and the strip shows however many
 * fit, with the next one peeking — that peek is what says "there is more".
 *
 * No `rewind` and no autoplay: a rail of past editions is browsed, not
 * presented, and an arrow that greys out at the end is the signal that the
 * reader has seen them all.
 *
 * The arrows are RETAIL_B's own buttons in the heading row (Splide picks up
 * `.splide__arrow--prev|next` anywhere under the root); their skin is
 * `.editions .splide__arrow` in components.css.
 */
import Splide from '@splidejs/splide';
import { qs, prefersReducedMotion } from './dom.js';

export function setupEditions() {
  const root = qs('[data-editions]');
  if (!root) return;

  // One card needs no carousel — see hero.js for the same guard.
  if (root.querySelectorAll('.splide__slide').length < 2) return;

  const splide = new Splide(root, {
    type: 'slide',
    fixedWidth: '15rem',
    gap: '1.25rem',
    perMove: 1,
    // Read from the document, never hardcoded — see hero.js.
    direction: document.documentElement.getAttribute('dir') === 'ltr' ? 'ltr' : 'rtl',
    arrows: true,
    pagination: false,
    // Stop at the last card instead of leaving blank track after it.
    trimSpace: 'move',
    speed: prefersReducedMotion() ? 0 : 500,
    // `lg` in tokens.css. mediaQuery 'min' so the breakpoint reads up from
    // the phone width, like the Tailwind classes beside it.
    mediaQuery: 'min',
    breakpoints: {
      1024: { fixedWidth: '17rem' },
    },
    i18n: {
      prev: 'دوره‌های قبلی',
      next: 'دوره‌های بعدی',
      carousel: 'دوره‌های گذشته',
      slide: 'دوره',
      slideLabel: 'دوره %s از %s',
    },
  });

  splide.mount();
  return splide;
}
